/** Shared typography for every page in the practice settings sidebar. */
export const practiceSettingsTitleSx = {
  fontSize: 22,
  lineHeight: 1.2,
  fontWeight: 650,
  m: 0,
} as const;

export const practiceSettingsSubtitleSx = {
  fontSize: 14,
  lineHeight: 1.43,
  fontWeight: 400,
  color: 'text.secondary',
  mt: 0.5,
} as const;
